import SSOTokenApi from "api/SSOTokenApi";
import { useQueryClient } from "@tanstack/react-query";
import { getTokenStaleTime } from "utils/utils";
import { IQueryOptions, QueryKey, useQueryWrapper } from "./api-hooks-common";

export const useGetSSOToken = (options: IQueryOptions) => {
  const queryClient = useQueryClient();

  const query = useQueryWrapper<string>(
    [QueryKey.SSO_TOKEN],
    () => SSOTokenApi.getSSOToken(),
    res => res.data!,
    {
      staleTime: 0,
      ...options,
    }
  );

  const token = query.data;
  if (token) {
    const staleTime = getTokenStaleTime(token);
    queryClient.setQueryDefaults([QueryKey.SSO_TOKEN], {
      staleTime,
    });
  }

  return query;
};

export default useGetSSOToken;
